// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__8wTNj","rootCenter":"LoadMoreObserver_rootCenter__1X-N-","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__wATDV"};